export default "__VITE_ASSET__e07a6159__"